import { categories } from '@/mocks/categories';

export default function CategoryDropdownSection() {
  return (
    <section className="py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            Shop by Category
          </h2>
          <p className="text-sm text-foreground-600 mb-8 max-w-xl mx-auto">
            Browse our curated product categories and find exactly what you need on Basetao Spreadsheet
          </p>

          <div className="relative inline-block">
            <select
              onChange={(e) => {
                if (e.target.value) {
                  window.open(e.target.value, '_blank', 'noopener,nofollow');
                  e.target.value = '';
                }
              }}
              className="appearance-none w-full sm:w-80 px-5 py-3.5 pr-12 bg-background-50 border-2 border-accent-300 rounded-lg text-sm font-medium text-foreground-900 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-100 transition-all cursor-pointer"
              defaultValue=""
            >
              <option value="" disabled>Select a category to explore...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>{cat.name}</option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-accent-600">
              <i className="ri-arrow-down-s-line text-lg"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}